import { render, staticRenderFns } from "./doc_one_rec_guide.vue?vue&type=template&id=56e462d0&scoped=true&"
import script from "./doc_one_rec_guide.vue?vue&type=script&lang=js&"
export * from "./doc_one_rec_guide.vue?vue&type=script&lang=js&"
import style0 from "./doc_one_rec_guide.vue?vue&type=style&index=0&id=56e462d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e462d0",
  null
  
)

export default component.exports